import { gql } from "@apollo/client";
import { ActivityFragment } from "domains/Request/graphql/fragments";
import { ReceiverInfoFragment } from "graphql/Receiver/fragments";
import { ParcelListFragment } from "./fragments";

export const GET_PARCELS = gql`
  query allParcels($queries: ParcelsFetchQueries) {
    results: allParcels(queries: $queries) {
      code
      error
      message
      countTotal
      currentPage
      parcels: data {
        ...ParcelListFragment
      }
    }
  }
  ${ParcelListFragment}
`;

export const GET_ALL_ARCHIVED_PARCELS = gql`
  query allArchivedParcels($queries: ParcelsFetchQueries) {
    results: allArchivedParcels(queries: $queries) {
      code
      error
      message
      countTotal
      currentPage
      parcels: data {
        ...ParcelListFragment
      }
    }
  }
  ${ParcelListFragment}
`;

export const RECAP_PARCEL_CLIENT = gql`
  query recapParcels($params: RecapParcelsFetchParams!, $queries: RecapParcelsFetchQueries) {
    recapParcels(params: $params, queries: $queries) {
      code
      message
      error
      data {
        successful {
          amount
          count
        }
        inprogress {
          amount
          count
        }
        cancelled {
          amount
          count
        }
      }
    }
  }
`;

export const RECAP_PARCELS = gql`
  query opsRecapParcels($queries: RecapParcelsFetchQueries) {
    opsRecapParcels(queries: $queries) {
      code
      message
      error
      data {
        successful {
          amount
          count
        }
        inprogress {
          amount
          count
        }
        cancelled {
          amount
          count
        }
      }
    }
  }
`;

export const GET_CASH_PARCEL_RECAP = gql`
  query getCashRecapParcels($queries: ParcelsCashRecapFetchQueries) {
    results: getCashRecapParcels(queries: $queries) {
      error
      code
      message
      data {
        status
        count
        amount
        parcels {
          ...ParcelListFragment
        }
      }
    }
  }
  ${ParcelListFragment}
`;

export const GET_PARCELS_BY_IDS = gql`
  query parcelByIds($queries: ManyParcelFetchQueries) {
    results: parcelByIds(queries: $queries) {
      code
      message
      data {
        ...ParcelListFragment
      }
    }
  }
  ${ParcelListFragment}
`;
export const GET_ALL_REMITTANCE = gql`
  query allRemittances($queries: RemittancesFetchQueries) {
    results: allRemittances(queries: $queries) {
      message
      code
      error
      data {
        _id
        type
        clientUID
        minDate
        maxDate
        client {
          _id
          client_UID
          client_company_name
        }
        status
        amountToRemit
        parcels {
          ...ParcelListFragment
        }
        createdAt
        remittanceUID
        confirmCreatedAt
        proof
        finalAmount
        receiverName
        receiverPhone
        costs
        badge
        declineReceptionReason
      }
    }
  }
  ${ParcelListFragment}
`;

export const GET_CLIENT_RECEIVERS = gql`
  query allReceiversByClient($params: ReceiversByClientFetchParams!, $queries: ReceiversByClientFetchQueries) {
    results: allReceiversByClient(params: $params, queries: $queries) {
      code
      error
      message
      data {
        ...ReceiverInfo
      }
    }
  }
  ${ReceiverInfoFragment}
`;

export const GET_REMITTANCE_RECAP = gql`
  query getRemittancesRecap($queries: RemittancesFetchQueries) {
    results: getRemittancesRecap(queries: $queries) {
      message
      code
      error
      data {
        badges {
          status
          amount
          count
        }
        remittances {
          _id
          type
          clientUID
          proof
          minDate
          maxDate
          additionalInfo
          client {
            _id
            client_UID
            client_company_name
            client_payment_mode
          }
          status
          amountToRemit
          finalAmount
          parcels {
            ...ParcelListFragment
          }
          createdAt
          remittanceUID
          confirmCreatedAt
          badge
          costs
          receiverName
          receiverPhone
          activities {
            ...ActivityFragment
          }
        }
      }
    }
  }
  ${ParcelListFragment}
  ${ActivityFragment}
`;
